<template>
  <div>
    <Upload :action="upload.action" :on-success="upload.fileUploadSuccessCall" :accept="upload.accept" :on-error="upload.error" :data="upload.param" :default-file-list="upload.list" :ref="upload.name+'fileUpload'">
      <Button ghost icon="ios-cloud-upload-outline" :disabled="upload.disabled">上传文件</Button>
    </Upload>
  </div>
</template>

<script>
  import { _api, util } from '@/libs';
  export default {
    name: 'FileUpload',
    props: {
      param: { type: Object },
      upload: { type: Object, required: true }
    },
    created() {
      const _this = this
      Object.assign(_this.upload, {
        action: _api.baseUrl + _api.common.libThird.oss,
        list: _this.upload.list,
        param: _this.param || _this.upload.param || {},
        fileUploadSuccessCall(payload, file, fileList) {
          _this.upload.fileList = fileList.map(node => {
            return {
              name: file.name,
              url: node.url || node.response.ossPath
            }
          })
          const result = _this.upload.single ? payload.ossPath : _this.upload.fileList.map(node => node.url)
          if (_this.upload.success) {
            _this.upload.success(payload, file, result)
          }
        }
      })
    }
  }
</script>

<style scoped>

</style>